<template>
  <div :class="'wrapper ' + config">
    <div class="content">
      <h1><span v-html="title" /></h1>
      <!-- <div v-if="with_button" class="french-button-wrapper">
        <v-btn height="54" :ripple="false" class="french-button">
          <img class="french-button-logo" src="https://storage.googleapis.com/mwm-website-v2-content/flag-fr.svg" >
          <span class="french-button-text">{{ frenchButtonText }}</span>
        </v-btn>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  props: ['title', 'config', 'with_button'],
  data: () => ({
    frenchButtonText: 'Passer en français',
  }),
};
</script>

<style scoped lang="scss">
@media (max-width: 960px) {
  .content h1 {
    width: 75%;
    margin: auto;
    font-size: 40px!important;
  }
}

.wrapper {
  display: table;
  width: 100%;
  height: 100vh;
  background-size: cover;
  background-position: center center;
}

.page-apps {
  background-image: url(https://storage.googleapis.com/mwm-website-v2-content/apps/page-apps.jpg);
}

.page-careers {
  background-image: url(https://storage.googleapis.com/mwm-website-v2-content/career/page-career-2.png);
}

.page-press {
  background-image: url(https://storage.googleapis.com/mwm-website-v2-content/press/page-press.jpg);
}

.page-home {
  background-image: url(https://storage.googleapis.com/mwm-website-v2-content/home/page-home.jpg);
}

.page-rd {
  background-image: url(https://storage.googleapis.com/mwm-website-v2-content/rd/page-rd.jpg);
}

.content {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  padding-bottom: 48px;
}

.content h1 {
  font-family: CenturyGothic;
  font-size: 60px;
  font-weight: bold;
  text-shadow: 0 2px 35px #000000;
  color: #ffffff;
  line-height: 1.17;
}

.french-button-wrapper {
  margin-top: 4rem;
}

.french-button {
  width: 263px;
  height: 53px;
  border-radius: 26.5px;
  background-color: #ffffff;
}

.french-button-text {
  font-family: Roboto;
  font-size: 18px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  text-transform: none;
  line-height: normal;
  letter-spacing: 0.17px;
  text-align: center;
  color: #141214;
}

.french-button-logo {
  height: 17px;
  width: 26px;
  margin-right: 1rem;
}
</style>
